(function($) {

  const searchform = document.querySelector('.search-form');
  const menuitem = document.querySelector('.main-menu__search-item');
  const closesearch = document.querySelector('.searchform-close');

  if( searchform && menuitem ) {
    $(menuitem).on('click', function(e) {
      e.preventDefault();
      $(searchform).addClass('show');
      setTimeout( () => { $(searchform).addClass('animate') }, 10);
    });
    $(closesearch).on('click', function(e) {
      e.preventDefault();
      $(searchform).removeClass('animate');
      setTimeout( () => { $(searchform).removeClass('show') }, 500);
    });
  }

})(jQuery);